import React from "react";
import Navbar from "@/components/Navbar";
import { Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

export default function AppLayout() {
    return (
        <div className="min-h-screen flex flex-col bg-background text-foreground">
            <Navbar />
            <main className="flex-1">
                <Outlet />
            </main>
            <footer className="border-t border-border py-6 px-6 mt-16">
                <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-muted-foreground">
                    <span className="font-mono">Prepcheck | Distributed practice engine | v0.1</span>
                    <span>Developed and operated by Illume AI Innovations Pvt Ltd.</span>
                </div>
            </footer>
            <Toaster position="top-right" />
        </div>
    );
}
